import "./App.css";
import { Routes, Route } from "react-router-dom";
import Login from "./screens/Login";
import React from "react";
import Settings from "./screens/Settings";
import Mac from "./screens/Mac";
import AllUser from "./screens/AllUser";
import EditUser from "./screens/EditUser";
import AddUser from "./screens/AddUser";
import SidebarPage from "./screens/NewDashboard";
import View from "./screens/View";
import DummyData from "./screens/DummyData";
import GlobalAlert from "./screens/GlobalAlerts";
import { MqttProvider } from "./mqtt/MqttProvider";

function App() {
  return (
    <>
      <MqttProvider>
        <GlobalAlert />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/mac" element={<Mac />} />
          <Route path="/alluser" element={<AllUser />} />
          <Route path="/adduser" element={<AddUser />} />
          <Route path="/edituser" element={<EditUser />} />
          <Route path="/dashboard" element={<SidebarPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/view" element={<View />} />
          <Route path="/dummydata" element={<DummyData />} />
        </Routes>
      </MqttProvider>
    </>
  );
}

export default App;
